export default "__VITE_ASSET__CZYV9CyL__"